import React, { Component } from 'react';
import { Container, Row, Col, Card, CardBody } from "reactstrap";
import PostApiCall from "../../Api";
import GetApiCall from "../../GETAPI";
import Notiflix from "notiflix";

import Upload from "../../assets/images/Upload.jpg";

class UploadCsv extends Component {
    constructor(props) {
        super(props);
        this.state = {
            StateData: []
        };
    }

    componentDidMount() {
        Notiflix.Loading.Init({
            svgColor: "#777f80",
        });

        // Notiflix.Loading.Dots("Please wait...");

        GetApiCall.getRequest("Get_State").then((resultdes) =>
            resultdes.json().then((obj) => {
                this.setState({
                    StateData: obj.data,
                });
                Notiflix.Loading.Remove();
            }))
    }
    render() {
        return (
            <React.Fragment>
                <div className="d-flex justify-content-center">
                    <div class="mt-3 price-card py-5 col-10">
                        <div>
                            <h3 className="stepper-heading d-flex justify-content-center align-items-center">To update pricing upload the CSV file with the latest pricing of products.</h3><br />
                        </div>
                        <div className="col-12">
                            <div className="row">
                                <div className="col-12 justify-content-center">
                                    <Card className="d-flex justify-content-center align-items-center download-container">
                                        <a className="download-csv">
                                            <img className="download-image" src={Upload} style={{ height: '250px', width: '250px' }}></img>
                                        </a>
                                        <button className="btn align-items-center downloadcsv-button mt-4 mb-4">Upload CSV</button>

                                    </Card>
                                    <h4 className="d-flex justify-content-center" style={{ fontWeight: 'bold' }}>Attach the CSV File to update the product pricing</h4>
                                    <h5 className="d-flex justify-content-center"><span>*</span> Double check your file before uploading. </h5>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </React.Fragment>
        )
    }
}
export default UploadCsv